var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('BgSidebar',{attrs:{"routes":_vm.routes,"testRoutes":_vm.sidebarRoutes}}),_c('div',{class:`dashboard__content ${
      _vm.expanded && 'dashboard__content--expanded'
    } ${_vm.fullWidth && 'dashboard__content--full'}`,style:({
      paddingLeft: _vm.leftPadding + 'px',
      paddingTop: _vm.topPadding + 'px',
    })},[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.$root.loading)?_c('bg-loader',{attrs:{"dark":true}}):_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }